import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2f2e254"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-card sso-invite-container" }
const _hoisted_2 = { class: "dialog-title" }
const _hoisted_3 = { class: "dialog-body" }
const _hoisted_4 = { class: "dialog-body" }
const _hoisted_5 = { class: "email-input" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 0,
  class: "dialog-error-message"
}
const _hoisted_9 = {
  class: "flex-container",
  style: {"width":"100%"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-plus",
  style: {"margin-right":"10px","color":"inherit"}
}, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "dialog-error-message"
}
const _hoisted_12 = { class: "flex-container" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-link" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-times",
  style: {"color":"inherit"}
}, null, -1))
const _hoisted_15 = {
  key: 1,
  class: "dialog-error-message"
}
const _hoisted_16 = {
  key: 2,
  class: "dialog-error-message"
}
const _hoisted_17 = { class: "dialog-actions" }
const _hoisted_18 = { style: {"margin-left":"auto","display":"flex"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_select = _resolveComponent("imdex-select")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("inviteSSOUsers.title")), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("inviteSSOUsers.titleDescr")), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", null, _toDisplayString(_ctx.$t("inviteSSOUsers.enterEmails")), 1),
        _createElementVNode("div", {
          class: "input-box",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.focusInput && _ctx.focusInput(...args)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emails, (email, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "chip"
            }, [
              _createTextVNode(_toDisplayString(email) + " ", 1),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.removeEmail(index))
              }, "x", 8, _hoisted_6)
            ]))
          }), 128)),
          _withDirectives(_createElementVNode("input", {
            ref: "emailInput",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newEmail) = $event)),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (($event.target as HTMLInputElement)?.blur()), ["prevent"]), ["enter"])),
            onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addEmail && _ctx.addEmail(...args))),
            class: _normalizeClass({ error: _ctx.emailInputErrorMessage !== '' }),
            placeholder: _ctx.$t(`inviteSSOUsers.emailInputPlaceholder`)
          }, null, 42, _hoisted_7), [
            [_vModelText, _ctx.newEmail]
          ])
        ]),
        (_ctx.emailInputErrorMessage !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.emailInputErrorMessage), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_imdex_select, {
          disabled: _ctx.globalRoles.length === 0,
          style: {"max-width":"300px"},
          items: _ctx.globalRoles,
          value: _ctx.userRole.value,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userRole.value) = $event)),
          "item-text": "roleName",
          label: _ctx.$t(`inviteSSOUsers.roleInputLabel`)
        }, null, 8, ["disabled", "items", "value", "label"]),
        _createVNode(_component_imdex_btn, {
          disabled: 
						_ctx.sites.length === 0 ||
						_ctx.siteRoles.length === 0 ||
						_ctx.sites.length == _ctx.sitePermissions.length
					,
          onClick: _ctx.addSite,
          style: {"font-weight":"500"},
          secondary: "",
          text: ""
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("inviteSSOUsers.addSite")), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      (_ctx.sites.length > 0 && _ctx.sites.length === _ctx.sitePermissions.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t("inviteSSOUsers.allAdded")), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sitePermissions, (siteRole, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_imdex_select, {
              ref_for: true,
              ref: "siteNameSelectors",
              items: _ctx.excludeSelectedSites(_ctx.sites, siteRole.siteId),
              label: _ctx.$t(`inviteSSOUsers.site`),
              value: siteRole.siteId,
              "onUpdate:value": ($event: any) => ((siteRole.siteId) = $event),
              disabled: _ctx.sites.length === _ctx.sitePermissions.length
            }, null, 8, ["items", "label", "value", "onUpdate:value", "disabled"]),
            _hoisted_13,
            _createVNode(_component_imdex_select, {
              ref_for: true,
              ref: "roleNameSelects",
              items: _ctx.siteRoles,
              label: _ctx.$t(`inviteSSOUsers.sitePermission`),
              value: siteRole.roleId,
              "onUpdate:value": ($event: any) => ((siteRole.roleId) = $event)
            }, null, 8, ["items", "label", "value", "onUpdate:value"]),
            _createVNode(_component_imdex_btn, {
              onClick: ($event: any) => (_ctx.removeSite(index)),
              text: "",
              secondary: ""
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]))
      }), 128)),
      (_ctx.fetchErrorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.fetchErrorMessage), 1))
        : _createCommentVNode("", true),
      (_ctx.submitError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.submitErrorMessage), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_imdex_btn, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.close())),
          text: "",
          secondary: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("inviteSSOUsers.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_imdex_btn, {
          style: {"margin-left":"10px"},
          secondary: "",
          onClick: _ctx.submitInvites,
          loading: _ctx.submittingInvites,
          disabled: !_ctx.isInviteValid || _ctx.submittingInvites
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("inviteSSOUsers.invite")), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"])
      ])
    ])
  ]))
}